// El contrato entrega `streamUrl` en `wss://` (openapi.yaml, FE-14). El mismo
// recurso se sirve por `https://` — es el transporte que el propio doc de
// cierre de BE-14 usa para verificar en vivo (EP-14-video-en-vivo.md §6:
// `sed 's|wss://|https://|'`), y evita depender de un loader WebSocket menos
// probado en el navegador para reproducir FLV/MSE.
export function toHttpsStreamUrl(streamUrl: string): string {
  return streamUrl.replace(/^wss:\/\//, 'https://').replace(/^ws:\/\//, 'http://');
}
